import React from 'react';
import ChevronDown from '@/icons/ChevronDown';
import ChevronRight from '@/icons/ChevronRight';

interface CollapsibleChevronProps {
  width?: number;
  height?: number;
  className?: string;
}

/** Open = down, closed = right. Parent Collapsible.Trigger must carry Radix `data-state`. */
const CollapsibleChevron: React.FC<CollapsibleChevronProps> = ({ width = 14, height = 14, className = '' }) => {
  const chevronClass = ['collapsible-chevron', className].filter(Boolean).join(' ');

  return (
    <span className="collapsible-chevron-wrap" aria-hidden>
      <ChevronDown width={width} height={height} className={`${chevronClass} collapsible-chevron--down`} />
      <ChevronRight width={width} height={height} className={`${chevronClass} collapsible-chevron--right`} />
    </span>
  );
};

export default CollapsibleChevron;
